import { motion } from "framer-motion";

export default function OpacityWrapper({ children, className }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      transition={{ delay: .1 }}
      whileInView={{ opacity: 1 }}
    >
      {children}
    </motion.div>
  );
}
